/**
 * kult-b2b-logo-box.js — Custom Element <kult-b2b-logo-box> (sections/kult-b2b-logo-box.liquid).
 * Zeigt das Firmenlogo aus der Unternehmensmischung (assets/kult-b2b-mischung.js) auf der Tüte in der Kult-Box und färbt
 * die Schleife in der dominierenden Logo-Farbe.
 * Ereignis-Vertrag: document-Event "kult:b2b:logo" mit detail { url, color, name, scale, kaffee }:
 *   url   → Logo-Bild setzen bzw. Platzhalter „Ihr Logo“ zeigen
 *   color → CSS-Variable --ribbon-color (rgb(…)); leer = Default Kult-Gold; sehr helle Farbe (relative Leuchtdichte
 *           > 0,85) → Klasse is-light-ribbon (feine Kontur in --color-hairline)
 *   scale → CSS-Variable --logo-scale
 * Hinweiszeile wechselt zwischen data-hint und data-hint-loaded (aria-live), Farbzeile unter dem Bild nur mit erkannter
 * Farbe. Beim Start "kult:b2b:logo-request", damit eine früher gestartete Mischung-Section ihren Stand nachreicht.
 * Kein Framework, keine externen Skripte.
 */
(function () {
  'use strict';
  if (customElements.get('kult-b2b-logo-box')) return;

  /* Relative Leuchtdichte (WCAG) aus „rgb(r, g, b)“; ungültig → -1 */
  function luminance(color) {
    var m = String(color || '').match(/rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/i);
    if (!m) return -1;
    var c = [m[1], m[2], m[3]].map(function (v) {
      var x = Math.min(255, parseFloat(v)) / 255;
      return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  class KultB2bLogoBoxEl extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.logoEl = this.querySelector('[data-box-logo]');
      this.placeholderEl = this.querySelector('[data-box-placeholder]');
      this.hintEl = this.querySelector('[data-box-hint]');
      this.colorLine = this.querySelector('[data-box-color-line]');
      this.stageEl = this.querySelector('[data-box-stage]');
      this.areaEl = this.querySelector('[data-box-area]');
      this.nameEl = this.querySelector('[data-box-name]');
      this.variants = Array.prototype.slice.call(this.querySelectorAll('[data-box-variant]'));
      this.baseLabel = this.stageEl ? this.stageEl.getAttribute('aria-label') || '' : '';
      this.hasLogo = false;
      this.onLogo = this.onLogoEvent.bind(this);
      document.addEventListener('kult:b2b:logo', this.onLogo);
      document.dispatchEvent(new CustomEvent('kult:b2b:logo-request'));
      var self = this;
      window.setTimeout(function () { self.armed = true; }, 1500);
    }

    disconnectedCallback() {
      document.removeEventListener('kult:b2b:logo', this.onLogo);
    }

    onLogoEvent(e) {
      var d = (e && e.detail) || {};
      var url = typeof d.url === 'string' ? d.url : '';
      var color = typeof d.color === 'string' ? d.color.trim() : '';
      var scale = parseFloat(d.scale);
      this.applyVariant(d);

      if (this.logoEl) {
        if (url) { if (this.logoEl.getAttribute('src') !== url) this.logoEl.src = url; this.logoEl.hidden = false; }
        else { this.logoEl.removeAttribute('src'); this.logoEl.hidden = true; }
      }
      if (this.placeholderEl) this.placeholderEl.hidden = !!url;
      /* Ohne Logo liegt das Standardbild (Kult-Box aus dem Privatkunden-Bereich) über dem Firmenfoto, mit Logo blendet es aus */
      this.classList.toggle('has-logo', !!url);

      if (url && color) this.style.setProperty('--ribbon-color', color);
      else this.style.removeProperty('--ribbon-color');
      this.classList.toggle('is-light-ribbon', !!(url && color) && luminance(color) > 0.85);
      if (this.colorLine) this.colorLine.hidden = !(url && color);

      if (isFinite(scale) && scale > 0) this.style.setProperty('--logo-scale', String(scale));
      else this.style.removeProperty('--logo-scale');

      if (this.hintEl && !!url !== this.hasLogo) {
        var text = url ? this.dataset.hintLoaded : this.dataset.hint;
        this.hintEl.textContent = text || '';
      }
      /* Nach dem Hochladen zur Vorschau springen, wenn sie nicht im Bild ist (auf dem Handy liegt sie unter dem Upload).
         Nicht beim Start, wenn nur ein gemerktes Logo wiederhergestellt wird. */
      if (url && !this.hasLogo && this.armed && this.stageEl && this.stageEl.scrollIntoView) {
        var box = this.stageEl.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (box.top < 0 || box.bottom > vh) {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.stageEl.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      this.hasLogo = !!url;
      if (this.stageEl && this.baseLabel) {
        this.stageEl.setAttribute('aria-label', this.baseLabel + (url ? ', mit Ihrem Logo auf der Tüte' + (color ? ' und Schleife in Ihrer Logo-Farbe' : '') : ''));
      }
    }
  }

  /* Bild je Kaffee: detail.handle wählt die Variante (Block „variant“), sonst gilt das Standardfoto. Die Logo-Fläche
     folgt dem gezeigten Foto. Hat die Variante eine Namensfläche, steht dort der Firmenname über der zweiten Zeile
     (detail.firma, detail.zeile2; ohne Eingabe „Ihre Firma“). */
  KultB2bLogoBoxEl.prototype.applyVariant = function (d) {
    var handle = typeof d.handle === 'string' ? d.handle.toLowerCase() : '';
    var picked = null;
    this.variants.forEach(function (v) {
      var on = !picked && !!handle && (',' + (v.dataset.boxVariant || '') + ',').indexOf(',' + handle + ',') > -1;
      v.hidden = !on;
      if (on) picked = v;
    });
    var setBox = function (el, str, prefix) {
      var p = String(str || '').split(',').map(function (x) { return parseFloat(x); });
      if (!el || p.length !== 4 || p.some(function (x) { return !isFinite(x); })) return false;
      ['x', 'y', 'w', 'h'].forEach(function (k, i) { el.style.setProperty('--' + prefix + '-' + k, p[i] + '%'); });
      return true;
    };
    if (this.areaEl) setBox(this.areaEl, (picked && picked.dataset.area) || this.areaEl.dataset.areaBase, 'area');
    if (this.nameEl) {
      var show = !!picked && setBox(this.nameEl, picked.dataset.nameArea, 'name');
      this.nameEl.hidden = !show;
      if (show) {
        var l1 = String(d.firma || '').trim() || 'Ihre Firma';
        var l2 = String(d.zeile2 || '').trim() || 'Mischung';
        var a = this.nameEl.querySelector('[data-box-name-1]'), b = this.nameEl.querySelector('[data-box-name-2]');
        if (a) a.textContent = l1;
        if (b) b.textContent = l2;
        this.nameEl.style.setProperty('--name-fit', String(Math.min(1, 10 / Math.max(l1.length, l2.length, 1))));
      }
    }
  };

  customElements.define('kult-b2b-logo-box', KultB2bLogoBoxEl);
})();
